import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import Layout from './components/common/Layout';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import FarmerMappings from './pages/FarmerMappings';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <Layout>
            <AppRoutes />
          </Layout>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
